Object.defineProperty(exports, "__esModule", { value: true });
exports.REACT_RENDER_OP = 'ui.react.render';
exports.REACT_UPDATE_OP = 'ui.react.update';
exports.REACT_MOUNT_OP = 'ui.react.mount';
//# sourceMappingURL=constants.js.map